import { IconContent } from '@icons';

export const star: IconContent = {
    sm: '<path fill-rule="evenodd" d="M8.975 4.282 7 0 5.025 4.282l-4.682.555 3.461 3.201-.919 4.625L7 10.36l4.114 2.303-.919-4.625 3.462-3.201-4.682-.555Zm2.412 1.293L8.3 5.209 7 2.388l-1.301 2.82-3.086.367 2.281 2.11-.605 3.047L7 9.214l2.711 1.518-.605-3.048 2.28-2.11Z" />',
    md: '<path fill-rule="evenodd" d="M14.96 7.92 12 1.5 9.04 7.92 2 8.76l5.2 4.8-1.38 6.93L12 17.04l6.17 3.45-1.38-6.93 5.2-4.8-7.03-.84Zm4.76 1.57-5.43-.64L12 3.89 9.71 8.85l-5.43.64L8.3 13.2l-1.07 5.36L12 15.9l4.77 2.67-1.07-5.36 4.02-3.7Z"/>',
};
